import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { SyncExternalBranchJobStatusLogAdminDto } from '@/backend/market'
import { ExternalBranchJobStatusLogEntity } from '../../domain/entities/ExternalBranchJobStatusLogEntity'

export class ExternalBranchJobStatusLogModel extends ExternalBranchJobStatusLogEntity {
  constructor(dataDto: SyncExternalBranchJobStatusLogAdminDto) {
    super()
    mapEntityProperties<ExternalBranchJobStatusLogModel>(this, dataDto)
  }
}
